module.exports = __webpack_public_path__ + "img/1.00f56ca0.jpg";